import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSearch, FaArrowRight } from 'react-icons/fa';
import Header from '../../Header';
import '../../scss/parentArticlesIndex.scss';

// Import the new ArticleCard component
import ArticleCard from './ArticleCard';

// Import the article data from ParentArticles component
// In a real app, this would come from an API
const PARENT_ARTICLES = [
  {
    id: 1,
    title: "Nutrition Tips for Young Athletes Before a Game",
    excerpt: "Simple meal ideas and nutrition advice to fuel your child's performance on match days and during training.",
    image: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?auto=format&fit=crop&w=600&h=400&q=80",
    slug: "nutrition-tips",
    category: "Nutrition",
    date: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    })
  }
];

// Array of category filters
const CATEGORIES = [
  "All",
  "Nutrition"
];

const ParentArticlesIndex = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [activeCategory, setActiveCategory] = useState('All');
  const [filteredArticles, setFilteredArticles] = useState(PARENT_ARTICLES);
  
  useEffect(() => {
    // Filter articles based on search term and active category
    const results = PARENT_ARTICLES.filter(article => {
      const matchesSearch = article.title.toLowerCase().includes(searchTerm.toLowerCase()) || 
                           article.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
      
      const matchesCategory = activeCategory === 'All' || article.category === activeCategory;
      
      return matchesSearch && matchesCategory;
    });
    
    setFilteredArticles(results);
  }, [searchTerm, activeCategory]);
  
  const handleCategoryChange = (category) => {
    setActiveCategory(category);
  };
  
  const navigateToArticle = (slug) => {
    navigate(`/parent/article/${slug}`);
  };
  
  return (
    <div className="parent-articles-index">
      <Header />
      
      <div className="page-container">
        <h2 className="audiowide">Parent Resources</h2>
        <p>Articles and guides to help you support your young footballer on and off the pitch</p>

        <div className="search-container">
          <div className="search-box">
            <FaSearch className="search-icon" />
            <input 
              type="text"
              placeholder="Search articles..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        
        <div className="categories-container">
          <div className="categories-scroll">
            {CATEGORIES.map(category => (
              <button 
                key={category}
                className={`category-button ${activeCategory === category ? 'active' : ''}`}
                onClick={() => handleCategoryChange(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
        
        {filteredArticles.length === 0 ? (
          <div className="no-results">
            <p>No articles found matching "{searchTerm}"</p>
            <button onClick={() => {setSearchTerm(''); setActiveCategory('All');}}>
              Clear filters
            </button>
          </div>
        ) : (
          <div className="articles-grid">
            {filteredArticles.map(article => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ParentArticlesIndex; 